import { useState } from 'react'

// Si el filtro cambia y se reutiliza la página actual, una coincidencia que
// solo existe en la primera página se ve como un listado vacío.
const useRequestPage = (param, currentPage, resetPage) => {
  const paramKey = JSON.stringify(param ?? null)
  const [boundParamKey, setBoundParamKey] = useState(paramKey)
  const filtersChanged = boundParamKey !== paramKey

  if (filtersChanged) {
    setBoundParamKey(paramKey)
    if (currentPage !== 1) {
      resetPage()
    }
  }

  return filtersChanged ? 1 : currentPage
}

export default useRequestPage
